import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/Users/yangwei/work/project/cat_help_admin/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import tags from "./tags";
import top from "./top/";
import sidebar from "./sidebar/";
import admin from '@/util/admin';
import { validatenull } from '@/util/validate';
import { getStore } from '@/util/store.js';
export default {
  components: {
    top: top,
    tags: tags,
    sidebar: sidebar
  },
  name: 'index',
  data: function data() {
    return {
      //刷新token锁
      refreshLock: false,
      //刷新token的时间
      refreshTime: '',
      // 计时器
      timer: ''
    };
  },
  created: function created() {
    //实时检测刷新token
    this.refreshToken();
  },
  destroyed: function destroyed() {
    clearInterval(this.refreshTime);
    clearInterval(this.timer);
    this.disconnect();
  },
  mounted: function mounted() {
    this.init();
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['userInfo', 'isLock', 'isCollapse', 'website', 'expires_in'])), {}, {
    key: function key() {
      return this.$route.path;
    }
  }),
  props: [],
  methods: {
    showCollapse: function showCollapse() {
      this.$store.commit("SET_COLLAPSE");
    },
    // 屏幕检测
    init: function init() {
      var _this = this;
      this.$store.commit('SET_SCREEN', admin.getScreen());
      window.onresize = function () {
        setTimeout(function () {
          _this.$store.commit('SET_SCREEN', admin.getScreen());
        }, 0);
      };
    },
    // 实时检测刷新token
    refreshToken: function refreshToken() {
      var _this2 = this;
      this.refreshTime = setInterval(function () {
        // 获取token
        var token = getStore({
          name: 'access_token',
          debug: true
        });
        // 判断是否有token
        if (validatenull(token)) {
          return;
        }
        // 过期时间 <= 1000 秒 并且 刷新token锁值为false
        if (_this2.expires_in <= 1000 && !_this2.refreshLock) {
          _this2.refreshLock = true;
          _this2.$store.dispatch('RefreshToken').catch(function () {
            clearInterval(_this2.refreshTime);
          });
          _this2.refreshLock = false;
        }
        _this2.$store.commit("SET_EXPIRES_IN", _this2.expires_in - 10);
      }, 10000);
    },
    disconnect: function disconnect() {
      if (this.stompClient != null) {
        this.stompClient.disconnect();
        console.log("Disconnected");
      }
    }
  }
};